<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        公司员工基础特权折扣为：
        <el-input v-model="formdata.conf_discount" class="w80 mr-5" disabled size="small"></el-input>折
        <el-button @click="modifydiscount" size="small">修改</el-button>
      </div>
      <p class="desc-info">员工的商城默认使用基础折扣特权，你也可以设置指定人员的个人特权折扣</p>
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <span class="choosedep">{{formdata.depart_name}}</span>
              <el-button @click="choosedep" size="small">选择部门</el-button>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formdata.is_person">只显示个人特权折扣</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formdata.name" placeholder="输入姓名" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="头像" width="180">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.pic" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="180"></el-table-column>
          <el-table-column prop="position" label="职务"></el-table-column>
          <el-table-column prop="department" label="部门"></el-table-column>
          <el-table-column prop="phone" label="手机"></el-table-column>
          <el-table-column label="特权折扣">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="settingsdiscount(scope.row)"
                size="small"
              >{{scope.row.discount}}折</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <chooseDepDialog
      :visible.sync="choosedepdialog"
      v-if="choosedepdialog"
      @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
    <discountDialog :visible.sync="discountdialog" v-if="discountdialog" @discountsucess="init"></discountDialog>
    <settingsDiscountDialog
      :employeeid="employeeid"
      :employeename="employeename"
      :discount_type="discounttype"
      :discount="discount"
      :visible.sync="settingsdiscountdialog"
      v-if="settingsdiscountdialog"
      @setdiscountsucess="init"
    ></settingsDiscountDialog>
  </div>
</template>
<script>
import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
import discountDialog from "@/components/dialog/discountDialog.vue";
import settingsDiscountDialog from "@/components/dialog/settingsDiscountDialog.vue";
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "employeePrivilege",
  components: {
    discountDialog,
    chooseDepDialog,
    settingsDiscountDialog
  },
  data() {
    return {
      formdata: {
        depart_name: "",
        depart_id: "",
        is_person: "",
        name: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      choosedepdialog: false,
      discountdialog: false,
      employeeid: "",
      employeename: "",
      discounttype: "",
      discount: "",
      settingsdiscountdialog: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 选择部门
    choosedep() {
      this.choosedepdialog = true;
    },
    choosedepsucess(val) {
      this.formdata.depart_name = val.name;
      this.formdata.depart_id = val.id;
    },
    // 修改
    modifydiscount() {
      this.discountdialog = true;
    },
    // 搜索
    search() {
      this.init();
    },
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex,
        depart_id: this.formdata.depart_id,
        is_person: this.formdata.is_person,
        name: this.formdata.name
      };
      this.axios
        .post(api.discount_index, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.conf_discount = response.data.conf_discount;
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 特权折扣
    settingsdiscount(row) {
      this.employeeid = row.id;
      this.employeename = row.name;
      this.discounttype = row.discount_type;
      this.discount = row.discount;
      this.settingsdiscountdialog = true;
    }
  }
};
</script>
